import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { fetchUpdateStoreModal, updateStore } from "../HTTPRequests/StoreRequests";
import Store from "../Models/Store";
import Mediator from "../Utilities/Mediator";
import DeleteStoreModal from "./DeleteStoreModal";
import StoreBaseModal from "./StoreBaseModal";

export default class UpdateStoreModal extends StoreBaseModal {
	modalDiv: HTMLDivElement;
	row: HTMLTableRowElement;
	oldStore: Store;

	constructor(row: HTMLTableRowElement) {
		super();
		this.modalDiv = document.createElement('div');
		this.row = row;
		this.init();
	}

	private init() {
		document.body.append(this.loadingScreen);
		this.fetchUpdateModal(this.row);
	}

	private fetchUpdateModal(row: HTMLTableRowElement) {
		fetchUpdateStoreModal(row.id)
			.then((response: string) => {
				this.openUpdateModal(response, row.id);
				this.oldStore = this.modalData.store;
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openUpdateModal(modalHTMLString: string, id: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);
		this.selectFormFields();
		this.addCVRValidator();
		new DeleteStoreModal(id, this.modalDiv).addDeleteModalClickListener();

		window.onclick = (event) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		const img: HTMLImageElement = document.querySelector('#update-store-modal img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#update-store-modal button:last-child');
		saveButton.onclick = () => {
			this.saveUpdatedStore(id);
		}

		const priceDifference = Number(this.priceDifferenceInput.value);

		if (priceDifference !== 0) {
			this.priceDifferenceInput.disabled = false;
			this.isPriceInputEnabled = true;

			let options: NodeListOf<HTMLOptionElement> = this.priceDifferenceSignSelect.querySelectorAll(`option[value="${priceDifference > 0 ? "1" : "-1"}"]`);
			if (window.getComputedStyle(options[0]).display === "none") {
				options[1].setAttribute("selected", "selected");
			} else {
				options[0].setAttribute("selected", "selected");
			}
		}

		if (priceDifference < 0) {
			this.priceDifferenceInput.value = this.priceDifferenceInput.value.substring(1);
		}

		this.addCustomerContactListerners();
	}

	private saveUpdatedStore(id: string) {
		let { valid, store }: { valid: boolean, store: Store } = this.modalData;
		if (valid) {
			if (store.isEqual(this.oldStore)) {
				this.modalDiv.remove();
			} else {
				store["id"] = id;
				this.updateStore(store);
			}
		} else {
			this.form.reportValidity();
		}
	}

	private updateStore(store: Store) {
		document.body.append(this.loadingScreen);
		updateStore(store)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("storeCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	public addCustomerContactListerners() {
		const customerContactWrapper: HTMLDivElement = document.querySelector("#economic-customer-contact-wrapper");
		if (customerContactWrapper) {
			const customerContactCheckbox: HTMLInputElement = document.querySelector("#economic-customer-contact");
			if (customerContactCheckbox.checked) {
				customerContactWrapper.style.display = "block";
			}

			customerContactCheckbox.onchange = () => {
				customerContactWrapper.style.display = customerContactCheckbox.checked ? "block" : "none";
			}
		}
	}
}
